/** Canais de mídia sociais */
export interface CanalMidiaSocial {
    id: number;
    nome: string;
    icon: string;
}

export const CanalMidiaSocialDesconhecido: CanalMidiaSocial = {
    id: 0,
    nome: 'Desconhecido',
    icon: 'far fa-question-circle'
};
export const CanalMidiaSocialFacebook: CanalMidiaSocial = {
    id: 1,
    nome: 'Facebook',
    icon: 'fab fa-facebook-square'
};
export const CanalMidiaSocialInstagram: CanalMidiaSocial = {
    id: 2,
    nome: 'Instagram',
    icon: 'fab fa-instagram'
};
export const CanalMidiaSocialLinkedin: CanalMidiaSocial = {
    id: 3,
    nome: 'Linkedin',
    icon: 'fab fa-linkedin'
};
export const CanalMidiaSocialWhatsApp: CanalMidiaSocial = {
    id: 4,
    nome: 'WhatsApp',
    icon: 'fab fa-whatsapp'
};
export const CanalMidiaSocialOutro: CanalMidiaSocial = {
    id: 99,
    nome: 'Outro',
    icon: 'far fa-question-circle'
};


export const canaisMidiasSociais: CanalMidiaSocial[] = [
    CanalMidiaSocialFacebook,
    CanalMidiaSocialInstagram,
    CanalMidiaSocialLinkedin,
    CanalMidiaSocialWhatsApp,
    CanalMidiaSocialOutro
];

/** Verifica se o canal de mídia social é Desconhecido */
export function isCanalMidiaSocialDesconhecido(id: number): boolean {
    return id === CanalMidiaSocialDesconhecido.id;
}

/** Verifica se o canal de mídia social é Facebook */
export function isCanalMidiaSocialFacebook(id: number): boolean {
    return id === CanalMidiaSocialFacebook.id;
}

/** Verifica se o canal de mídia social é Instagram */
export function isCanalMidiaSocialInstagram(id: number): boolean {
    return id === CanalMidiaSocialInstagram.id;
}

/** Verifica se o canal de mídia social é Linkedin */
export function isCanalMidiaSocialLinkedin(id: number): boolean {
    return id === CanalMidiaSocialLinkedin.id;
}

/** Verifica se o canal de mídia social é WhatsApp */
export function isCanalMidiaSocialWhatsApp(id: number): boolean {
    return id === CanalMidiaSocialWhatsApp.id;
}

/** Verifica se o canal de mídia social é Outro */
export function isCanalMidiaSocialOutro(id: number): boolean {
    return id === CanalMidiaSocialOutro.id;
}
